import { ApplicationExceptionHandler, errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { WorkstationCategoryService } from './workstation-category.service';
import { WorkstationCategoryDTO } from './dto/workstation-category.dto';
import { WorkstationCategoryResponseModel, AllWorkstationCategoryResponseModel } from '@gtpl/shared-models/production-management';
import { WorkstationCategoryRequest } from './dto/workstatin-category.request';

@ApiTags('Workstation-category')
@Controller('workstation-category')
export class WorkstationCategoryController {
    constructor(
        private workstationCategoryService: WorkstationCategoryService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
    /**
     * Creates workstation category
     * @param workstationCategoryDTO 
     * @param isUpdate 
     * @param request 
     * @returns 
     */
    @Post('/createWorkstationCategory')
    async createWorkstationCategory(@Body() workstationCategoryDTO:WorkstationCategoryDTO,isUpdate:boolean=false,@Req() request:Request): Promise<WorkstationCategoryResponseModel> {
        try {
            return await this.workstationCategoryService.createWorkstationCategory(workstationCategoryDTO, false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(WorkstationCategoryResponseModel, error)
        }
    }
    /**
     * 
     * @param workstationCategoryDTO 
     * @param request 
     * @returns 
     */
    @Post('/updateWorkstationCategory')
    async updateWorkstationCategory(@Body() workstationCategoryDTO: WorkstationCategoryDTO,@Req() request:Request): Promise<WorkstationCategoryResponseModel> {
        try {
        return await this.workstationCategoryService.createWorkstationCategory(workstationCategoryDTO, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(WorkstationCategoryResponseModel, error)
        }
    }
    /**
     * 
     * @param request 
     * @returns 
     */
    @Post('/getAllWorkstationCategories')
    async getAllWorkstationCategories(@Req() request: Request): Promise<AllWorkstationCategoryResponseModel> {
        try {
        return await this.workstationCategoryService.getAllWorkstationCategories();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllWorkstationCategoryResponseModel, error)
        }
    }
    @Post('/activateorDeactivateWorkstationCategory')
    async activateorDeactivateWorkstationCategory(@Body() workstationCategoryReq: WorkstationCategoryRequest): Promise<WorkstationCategoryResponseModel> {
        try {
            return await this.workstationCategoryService.activateorDeactivateWorkstationCategory(workstationCategoryReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(WorkstationCategoryResponseModel, err);
        }
    }

    @Post('/getAllActiveWorkstationCategories')
    async getAllActiveWorkstationCategories(@Req() request: Request): Promise<AllWorkstationCategoryResponseModel> {
        try {
        return await this.workstationCategoryService.getAllActiveWorkstationCategories();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllWorkstationCategoryResponseModel, error)
        }
    }
}
